module.exports = __webpack_public_path__ + "static/media/xb3.277513e7.jpg";